export class ZoneModalInfo {
  constructor() {
    if (ZoneModalInfo.instance) {
      return ZoneModalInfo.instance;
    }
    ZoneModalInfo.instance = this;
    this.lastOpend = {};
    this.htmlElement = document.querySelector("#zoneInfoModal");
    this.titleModalZone = document.querySelector("#titleModalZone");
    this.subtitleModalZone = document.querySelector("#subtitleModalZone");
    this.colorimetryMenu = document.querySelector("#colorimetryMenu");
    this.availableBar = document.querySelector("#availableBar");
    this.screenOne = document.querySelector("#screen-one");
    this.screenTwo = document.querySelector("#screen-two");
    this.seccionTitleModalZone = document.querySelector(
      "#seccionTitleModalZone"
    );
    this.closeIconZoneModal = document.querySelector("#iconCloseZoneInfoModal");
    this.eventListenners();
  }

  showModal(name = "", isClouster = false, entrySubtitle = "") {
    if (name === "") {
      name = this.lastOpend.name;
      isClouster = this.lastOpend.isClouster;
    }
    if (isClouster) {
      this.colorimetryMenu.classList.remove("hidden");
      this.titleModalZone.innerText = name;
      // TODO: metodo para cambiar porcentaje de la barra de disponibilidad
      this.availableBar.classList.remove("hidden");
      this.availableBar.classList.add("flex");
      this.subtitleModalZone.innerText = "CLUSTER";
      this.seccionTitleModalZone.classList.replace("w-full", "w-7/12");
    } else {
      this.availableBar.classList.remove("flex");
      this.availableBar.classList.add("hidden");
      if (entrySubtitle === "") {
        this.colorimetryMenu.classList.add("hidden");
        this.titleModalZone.innerText = name;
        this.subtitleModalZone.innerText = "ZONA";
        this.seccionTitleModalZone.classList.replace("w-7/12", "w-full");
      } else {
        this.colorimetryMenu.classList.add("hidden");
        this.titleModalZone.innerText = name;
        this.subtitleModalZone.innerText = entrySubtitle;
        this.seccionTitleModalZone.classList.replace("w-7/12", "w-full");
      }
    }
    if (this.htmlElement.classList.contains("hidden")) {
      this.htmlElement.classList.replace("hidden", "flex");
    }

    if (this.titleModalZone.innerText === "ACCESO POR CASCADASA") {
      this.titleModalZone.classList.replace("lg:text-4xl", "lg:text-3xl");
      this.titleModalZone.classList.replace("md:text-4xl", "md:text-3xl");
      this.screenOne.classList.replace("w-3/5", "w-3/4");
      this.screenTwo.classList.replace("w-2/5", "w-1/4");
    } else {
      this.titleModalZone.classList.replace("lg:text-3xl", "lg:text-4xl");
      this.titleModalZone.classList.replace("md:text-3xl", "md:text-4xl");
      this.screenOne.classList.replace("w-3/4", "w-3/5");
      this.screenTwo.classList.replace("w-1/4", "w-2/5");
    }

    this.lastOpend.name = name;
    this.lastOpend.isClouster = isClouster;
  }
  hideModal() {
    if (this.htmlElement.classList.contains("flex")) {
      this.htmlElement.classList.replace("flex", "hidden");
    }
  }

  eventListenners() {
    this.closeIconZoneModal.addEventListener("click", () => {
      this.hideModal();
    });
  }
}
